<template>
  <div v-if="item" class="body">
    <div class="details-box">
      <div class="top-box">
        <img class="head-img" :src="item.clerkAvatarUrl">
        <div class="user-intel">
          <div class="name-sex">
            <div class="name">{{item.clerkName}}</div>
            <div class="sex-age">
              <span class="men" v-if="item.sex == $store.state.ClerkSexEnum.MEN.value"><van-icon name="/static/images/default/post-male.png" size="13"/></span>
              <span class="women" v-else><van-icon name="/static/images/default/post-female.png" size="13"/></span>
            </div>
          </div>
          <div class="dynamic-date">{{ formatDate(item.createTime, 'YYYY-MM-DD HH:mm') }}</div>
        </div>
        <div class="delete" @click="deletePost(item.id)">
          删除动态
        </div>
      </div>
      <div class="content-box">
        <div class="text" v-if="item.content">{{item.content}}</div>
        <div v-if="item.photoUrls.length > 0" class="img-box">
          <van-image v-for="(img,index) in item.photoUrls"
                     :key="index"
                     style="margin: 0 5px 5px 0;"
                     :width="item.photoUrls.length == 1 ? 170 : 112"
                     :height="item.photoUrls.length == 1 ? 170 : 112"
                     fit="contain"
                     :src="img"
                     @click="handleClickImg(item.photoUrls, index)"
          />
        </div>
        <div v-show="item.videoUrl" class="video">
          <video width="100%" height="200px" :poster="item.videoUrl + '?ci-process=snapshot&time=1'" :src="item.videoUrl" controls="controls" @play="handlePlay(0)"></video>
        </div>
        <div v-if="item.audioUrl">
          <div class="audio-player" :class="player.id == item.id ? 'playing' : ''"
               @click="playAudio(item.id, item.audioUrl)">
            <div class="audio">
              <div class="audio-icon">
                <img src="/static/images/default/play.png" style="width: 8px; height: 8px" v-if="player.id == item.id"/>
                <img src="/static/images/default/play-stop.png" style="width: 8px; height: 8px" v-else/>
              </div>
              <div class="duration">{{ formatAudioDuration(item.audioDuration) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="interval"></div>
    <div class="comment-title" ref="targetDiv">评论</div>
    <van-list
        v-model="loading"
        :finished="listFinished"
        @load="loadComment"
        class="comment-list"
    >
      <div class="comment-item" v-for="(comment, index) in comment.commentList" :key="index">
        <img :src="comment.headImgUrl" class="headImg">
        <div class="right-box">
          <div class="name">
            {{ comment.nickname }}
            <span class="op" v-if="comment.objectId == item.clerkId && comment.role == 'clerk'">楼主</span>
            <span class="my" v-if="comment.isSelf">我</span>
          </div>
          <div class="content">{{ comment.content }}</div>
          <div class="time">
            <span class="createTime">{{ showDate(comment.createTime) }}</span>
            <span class="reply" @click="reply(comment.id, comment.nickname)">回复</span>
            <span class="delete" @click="deleteComment(comment.id)">删除</span>
          </div>
          <div>
            <div class="expand-comment-item" v-for="(expandComment, index2) in comment.expandComments" :key="index2">
              <img :src="expandComment.headImgUrl" class="headImg">
              <div class="expand-right-box">
                <div class="name">
                  {{ expandComment.nickname }}
                  <span class="op" v-if="expandComment.objectId == item.clerkId && expandComment.role == 'clerk'">楼主</span>
                  <span class="my" v-if="expandComment.isSelf">我</span>
                  <span class="reply" v-if="comment.nickname != expandComment.replyNickname">
                    <van-icon name="/static/images/default/arrowright-i.png" size="10" class="reply-icon"/>
                    {{ expandComment.replyNickname }}
                    <span class="op" v-if="expandComment.replyObjectId == item.clerkId && expandComment.replyRole == 'clerk'">楼主</span>
                    <span class="my" v-if="expandComment.replyIsSelf">我</span>
                  </span>
                </div>
                <div class="content">
                  <span>{{ expandComment.content }}</span>
                </div>
                <div class="time">
                  <span class="createTime">{{ showDate(expandComment.createTime) }}</span>
                  <span class="reply" @click="reply(expandComment.id, expandComment.nickname)">回复</span>
                  <span class="delete" @click="deleteComment(expandComment.id)">删除</span>
                </div>
              </div>
            </div>
          </div>
          <div class="hide" v-if="comment.replyCount > 0 && !comment.isExpand" @click="expandComment(comment.id)">
            <span class="hide-line">—</span>
            <span class="hide-text">
              展开{{ comment.replyCount }}条回复
            </span>
            <span class="hide-icon">
              <van-icon name="/static/images/default/arrowbuttom-o.png" size="12"/>
            </span>
          </div>
          <div v-if="comment.isExpand" class="expand">
            <span class="expand-line" v-if="comment.hasNextPage">—</span>
            <span class="expand-more" v-if="comment.hasNextPage" @click="expandComment(comment.id)">
              展开更多
              <van-icon name="/static/images/default/arrowbuttom-o.png" size="12"/>
            </span>
            <span class="hide" @click="hideComment(comment.id)">
              收起
              <van-icon name="/static/images/default/arrowtop-o.png" size="12"/>
            </span>
          </div>
        </div>
      </div>
      <div class="no-many">暂无更多数据</div>
    </van-list>

    <div v-if="sendingShow" ref="box" class="sending-box">
      <div class="sending-unFocus-box">
        <van-field
            class="sending-textarea"
            v-model="sending"
            rows="1"
            :autosize="{ maxHeight: 70 }"
            type="textarea"
            button-text="发送"
            @click-button="send"
            :placeholder="replyCommentId ? `回复 @${replyNickname}` : '文明发言'"
            ref="textarea"
            maxlength="100"
            :show-word-limit="showWordLimit"
            @focus="handleFocus"
            @blur="handleBlur"/>
        <div class="like" v-if="!showWordLimit">
          <van-icon size="22" :name="item.isLiked ? 'good-job' : 'good-job-o'"
                    :class="item.isLiked ? 'liked' : ''"/>
          <div class="like-num">
            <span>{{ item.likeCount }}</span>
          </div>
        </div>
      </div>
      <div class="sending-button" v-if="showWordLimit">
        <span :class="sending.length > 0 ? 'sending-text' : 'un-sending-text'" @mousedown ="send">发送</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Search,
  Swipe,
  SwipeItem,
  Button,
  List,
  Cell,
  CellGroup,
  Tag,
  Icon,
  ActionSheet,
  Dialog,
  Popup,
  Tab,
  Tabs,
  Toast,
  ImagePreview,
  Image as VanImage,
  Field
} from 'vant';
import {deletedPost, getClerkPostInfo,} from "@/api/clerk/post";
import {addComment, deleteComment, expandComment, getClerkPostCommentList} from "@/api/clerk/post_comment";
import Decimal from "decimal.js";

Vue.use(Search)
    .use(Swipe)
    .use(SwipeItem)
    .use(Button)
    .use(List)
    .use(Cell)
    .use(CellGroup)
    .use(Tag)
    .use(Icon)
    .use(ActionSheet)
    .use(Dialog)
    .use(Popup)
    .use(Tab)
    .use(Tabs)
    .use(VanImage)
    .use(Toast)
    .use(Field)
    .use(ImagePreview)


export default {
  name: 'post-detail',
  components: {},
  data() {
    return {
      item: null,
      loading: false,
      listFinished: false,
      list: [],
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      sending: null,
      sendingShow: true,
      comment: {
        commentList: [],
        total: null,
        hasNextPage: null,
        allowComment: null
      },
      player: {
        id: null,
        audio: null
      },
      videoElement: [],
      expandCommentPageArr: [],
      replyCommentId: null,
      replyNickname: null,
      showWordLimit: false,
    }
  },

  methods: {
    send(){
      this.sendingClick()
      this.$refs.textarea.blur()
    },
    deletePost(postId) {
      Dialog.confirm({
        title: '温馨提示',
        message: '确定要删除此动态吗?',
      }).then(() => {
        Toast.loading({
          overlay: true,
          message: '请稍候...'
        })
        deletedPost(postId).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            Toast.success('删除成功')
            this.$router.push({
              path: '/clerk/post/list'
            })
          } else {
            Toast.success('删除失败')
          }
        })
      }).catch(() => {

      });
    },
    handleBlur() {
      this.showWordLimit = false
      this.replyCommentId = null
    },
    handleFocus() {
      this.showWordLimit = true
    },
    deleteComment(commentId) {
      Dialog.confirm({
        title: '确定要删除该评论吗'
      }).then(() => {
        deleteComment(commentId).then(res => {
          const data = res.data
          if (data.code == 0) {
            Toast('删除成功')
          } else {
            Dialog.alert({
              title: '删除失败',
              message: data.msg
            })
          }
          this.loadData()
        })
      })
    },
    showDate(createTime) {
      return new Date(createTime).getFullYear() == new Date().getFullYear()
          ? this.formatDate(createTime, 'MM-DD HH:mm')
          : this.formatDate(createTime, 'YYYY-MM-DD HH:mm');
    },
    reply(commentId, nickname) {
      this.replyCommentId = commentId
      this.replyNickname = nickname
      this.sendingShow = true
      this.$refs.textarea.focus()
    },
    sendingClick() {
      if(!this.comment.allowComment){
        Toast('已关闭评论')
        return
      }
      if (this.sending == null || this.sending.length == 0) {
        Toast('请输入评论内容')
        return
      }
      if (this.sending.length > 100) {
        Toast('评论内容不能超过100个字')
        return
      }
      Toast.loading({
        overlay: true,
        message: '请稍候...'
      })
      addComment(this.item.id, this.sending, this.replyCommentId).then(res => {
        const data = res.data;
        if (data.code == 0) {
          Toast.clear()
          Toast('发送成功');
          this.sending = null
        } else {
          Dialog.alert({
            title: '发送失败',
            message: data.msg
          })
        }
        this.sending = null
        this.replyCommentId = null
        this.replyNickname = null
        this.loadData()
      })
    },
    hideComment(commentId) {
      const foundComment = this.comment.commentList.find(item => item.id == commentId)
      foundComment.isExpand = false
      foundComment.expandComments = []
      let expandCommentPage = this.expandCommentPageArr.find(item => item.commentId == commentId)
      expandCommentPage.pageNo = 1
    },
    expandComment(commentId) {
      const foundComment = this.comment.commentList.find(item => item.id == commentId)
      this.$set(foundComment, 'isExpand', true)

      let expandCommentPage = this.expandCommentPageArr.find(item => item.commentId == commentId)
      if (!expandCommentPage) {
        expandCommentPage = {
          commentId: commentId,
          pageNo: 1,
          pageSize: 10
        }
      }
      this.expandCommentPageArr.push(expandCommentPage)

      Toast.loading({
        overlay: true,
        message: '请稍候...'
      })
      expandComment(commentId, expandCommentPage.pageNo, expandCommentPage.pageSize).then(res => {
        Toast.clear()
        const data = res.data
        if (data.code == 0) {
          const foundComment = this.comment.commentList.find(item => item.id == commentId)
          if (!foundComment.expandComments) {
            this.$set(foundComment, 'expandComments', [])
          }
          this.$set(foundComment, 'hasNextPage', data.hasNextPage)
          foundComment.expandComments = foundComment.expandComments.concat(data.list)
          expandCommentPage.pageNo++
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
    formatAudioDuration(duration) {
      if (duration != null) {
        duration = Decimal.div(duration, 1000).toFixed(0)
        if (duration.length < 2) {
          duration = '0' + duration
        }
        return duration + 's"'
      }
      return ''
    },
    playAudio(id, audioUrl) {
      if (this.player.audio != null) {
        this.player.audio.pause()
      }
      if (this.player.id == id) {
        this.player.id = null
        this.player.audio = null
      } else {
        const videoElement = this.videoElement
        for (let i = 0; i < videoElement.length; i++) {
          this.videoElement[i].pause()
        }
        const audio = new Audio(audioUrl)
        audio.play()
        // 播放结束事件
        audio.onended = () => {
          this.player.id = null
          this.player.audio = null
        }
        this.player.id = id
        this.player.audio = audio
      }
    },
    handlePlay(index) {
      const videoElement = this.videoElement
      if (videoElement && videoElement.length > 0) {
        for (let i = 0; i < videoElement.length; i++) {
          if (i == index) {
            this.videoElement[i].play()
            this.player.id = null
            this.player.audio = null
          } else {
            this.videoElement[i].pause()
          }
        }
      }
    },
    handleClickImg(photoUrls, index) {
      ImagePreview({
        images: photoUrls,
        startPosition: index,
      });
    },
    to(id) {
      this.$router.push({
        path: '/clerk/detail/' + id
      })
    },
    loadData() {
      getClerkPostInfo(this.$route.params.id).then(res => {
        const data = res.data
        if (data.code == 0) {
          this.item = data.clerkPostInfo
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
      this.loadComment(true)
      this.expandCommentPageArr = []
      this.handleBlur()
      this.videoElement = document.getElementsByTagName('video')
    },
    loadComment(resetFirstPage) {
      if (resetFirstPage) {
        this.page.pageNo = 1
      }
      if (this.page.pageNo == 1) {
        this.comment.commentList = []
      }
      this.loading = true
      getClerkPostCommentList(
          this.$route.params.id,
          this.page.pageNo,
          this.page.pageSize).then(res => {
        this.loading = false
        const data = res.data
        if (data.code == 0) {
          this.comment.commentList = this.comment.commentList.concat(data.list)
          this.comment.total = data.total
          this.comment.hasNextPage = data.hasNextPage
          this.comment.allowComment = data.allowComment
          if (data.hasNextPage) {
            this.listFinished = false
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.page.pageNo++
      })
    }
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style lang="less" scoped>
.body {
  min-height: 100vh;
  background: #fff;

  .details-box {
    padding: 19px 19px 20px 20px;

    .top-box {
      display: flex;
      align-items: center;

      .head-img {
        width: 37px;
        height: 37px;
        border-radius: 50%;
        display: block;
        object-fit: cover;
      }

      .user-intel {
        flex: 1;
        padding: 0 9px;
        display: flex;
        justify-content: space-between;
        flex-flow: column;
        height: 30px;

        .name-sex {
          display: flex;
          align-items: center;

          .name {
            font-size: 15px;
            color: #191919;
            line-height: 14px;
            margin-right: 3px;
          }

          .sex-age {
            height: 13px;
            padding: 0 4px;
            display: flex;
            align-items: center;
            border-radius: 999px;
            font-size: 9px;
            color: #FFFFFF;

            img {
              display: block;
              margin-right: 2px;
            }
          }
        }
        .dynamic-date{
          font-size: 11px;
          color: #ACACAC;
        }
      }
      .delete{
        color: #999999;
      }

      .concern {
        height: 26px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        padding: 0 7px;
        font-size: 12px;
        border: 1px #9AC2F9 solid;
        color: #9AC2F9;
        border-radius: 999px;

        img {
          width: 10px;
          height: 10px;
          display: block;
          margin-right: 3px;
        }
      }

      .no-concern {
        color: #B3B3B3;
        border: 1px #B3B3B3 solid;
      }
    }

    .content-box {
      width: 100%;

      .title {
        word-wrap: break-word;
        font-weight: bold;
        font-size: 15px;
        color: #333333;
        line-height: 15px;
        margin-bottom: 8px;
      }

      .text {
        word-wrap: break-word;
        line-height: 22px;
        font-weight: 500;
        font-size: 15px;
        color: #191919;
        margin-top: 14px;
      }

      .img-box {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 12px;

        .img-style {
          width: 32%;
          padding-top: 32%;
          position: relative;
          margin: 0 0 1.6vw 0;

          img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            display: block;
            object-fit: cover;
            border-radius: 8px;
          }
        }

        .img-no {
          width: 32%;
        }
      }

      .video {
        margin-top: 12px;
      }
      .audio-player {
        width: 84px;
        height: 33px;
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        align-items: center;
        background-size: cover;
        background-color: #DEE9FF;
        border-radius: 50px;
        margin-top: 18px;
        z-index: 3;
        .audio {
          width: 100%;
          padding: 0 15px 0 9px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .audio-icon{
            background-color: rgba(120, 167, 255, 0.85);
            border-radius: 50%;
            width: 14px;
            height: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .duration {
            font-size: 10px;
            font-weight: bold;
            color: #5892FF;
          }
        }

        &.playing {
          .wave {
            @keyframes wave {
              from {
                height: 18px;
              }
              to {
                height: 12px;
              }
            }
            animation: wave .5s linear 0s infinite alternate;
          }
        }
      }
      .come-form {
        margin-top: calc(17px - 1.6vw);
        padding: 0 8px;
        height: 21px;
        background: #F6F6F6;
        border-radius: 10px;
        font-size: 11px;
        line-height: 21px;
        display: inline-block;
        color: #9AC2F9;

        .title-color {
          color: #333;
        }
      }

      .time {
        font-weight: 500;
        font-size: 12px;
        color: #999999;
        line-height: 11px;
        margin-top: 10px;
      }
    }
  }

  .interval {
    height: 10px;
    background: #F5F6F7;
  }
  .comment-title{
    font-weight: bold;
    font-size: 15px;
    color: #333333;
    margin: 10px 15px;
  }
  .comment-list {
    padding: 0 39px 0 14px;

    .list-title {
      font-weight: bold;
      font-size: 15px;
      line-height: 15px;
      color: #333333;
      padding: 16px 0 3px 0;
    }

    .comment-item {
      padding: 14px 0 0 0;
      display: flex;

      .headImg {
        display: block;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        object-fit: cover;
        margin-right: 13px;
      }

      .right-box {
        flex: 1;
        border-bottom: 1px #F5F5F5 solid;
        padding-bottom: 14px;

        .name {
          font-size: 13px;
          color: #999;
          display: flex;
          align-items: center;
          .op{
            color: white;
            background-color: #5892FF;
            border-radius: 2px;
            font-size: 10px;
            font-weight: 500;
            margin-left: 5px;
            height: 15px;
            width: 29px;
            text-align: center;
            line-height: 15px;
          }
          .my{
            color: #525258;
            background-color: #F3F3F3;
            border-radius: 2px;
            font-size: 10px;
            margin-left: 5px;
            height: 15px;
            width: 19px;
            text-align: center;
            line-height: 15px;
          }
        }

        .content {
          margin-top: 5px;
          font-size: 14px;
          color: #333333;
          line-height: 20px;
          width: 280px;
          overflow-wrap: break-word;
          text-align: left;
        }

        .time {
          margin-top: 5px;
          font-size: 12px;

          .createTime {
            color: rgb(187, 187, 187);
          }

          .reply {
            color: #4D4D4D;
            cursor: pointer;
            margin-left: 10px;
          }

          .delete {
            color: #999999;
            cursor: pointer;
            margin-left: 10px;
          }
        }

        .expand-comment-item {
          display: flex;
          margin-top: 10px;

          .headImg {
            display: block;
            border-radius: 50%;
            width: 30px;
            height: 30px;
            object-fit: cover;
            margin-right: 13px;
          }

          .expand-right-box {
            .name {
              font-size: 13px;
              color: #999;
              display: flex;
              align-items: center;
              .op{
                color: white;
                background-color: #5892FF;
                border-radius: 2px;
                font-size: 10px;
                font-weight: 500;
                margin-left: 5px;
                height: 15px;
                width: 29px;
                text-align: center;
                line-height: 15px;
              }
              .my{
                color: #525258;
                background-color: #F3F3F3;
                border-radius: 2px;
                font-size: 10px;
                margin-left: 5px;
                height: 15px;
                width: 19px;
                text-align: center;
                line-height: 15px;
              }
              .reply{
                display: flex;
                align-items: center;
                .reply-icon{
                  margin-left: 10px;
                  margin-right: 10px;
                }
                .op{
                  color: white;
                  background-color: #5892FF;
                  border-radius: 2px;
                  font-size: 10px;
                  font-weight: 500;
                  margin-left: 5px;
                  height: 15px;
                  width: 29px;
                  text-align: center;
                  line-height: 15px;
                }
                .my{
                  color: #525258;
                  background-color: #F3F3F3;
                  border-radius: 2px;
                  font-size: 10px;
                  margin-left: 5px;
                  height: 15px;
                  width: 19px;
                  text-align: center;
                  line-height: 15px;
                }
              }
            }

            .content {
              margin-top: 5px;
              font-size: 14px;
              color: #333333;
              line-height: 20px;
              width: 280px;
              overflow-wrap: break-word;
              text-align: left;
            }

            .time {
              margin-top: 5px;
              font-size: 12px;

              .createTime {
                color: rgb(187, 187, 187);
              }

              .reply {
                color: #4D4D4D;
                cursor: pointer;
                margin-left: 10px;
              }

              .delete {
                color: #999999;
                cursor: pointer;
                margin-left: 10px;
              }
            }
          }
        }

        .hide {
          margin-top: 10px;
          .hide-line{
            color: #EEEEEE;
          }
          .hide-text{
            color: grey;
            font-size: 12px;
            margin-left: 10px;
          }
        }

        .expand {
          margin-top: 10px;
          .expand-line{
            color: #EEEEEE;
          }
          .expand-more {
            font-size: 12px;
            color: grey;
            margin-right: 25px;
          }

          .hide {
            font-size: 12px;
            color: grey;
          }
        }
      }
    }

    .no-many {
      padding: 16px 0 80px 0;
      font-size: 12px;
      line-height: 12px;
      text-align: center;
      color: #ccc;
    }
  }

  .foot-box {
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    height: 57px;
    width: 100%;
    display: flex;
    align-items: center;

    .item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      color: #8B8B8B;

      img {
        width: 17px;
        height: 17px;
        display: block;
        margin-right: 7px;
      }
    }
  }

  .sending-box{
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 10px 17px;
    background: #fff;
    width: calc(100% - 17px * 2);
    .sending-unFocus-box{
      display: flex;
      align-items: center;
      /deep/.van-cell{
        background: #F4F5F7;
        border-radius: 4px;
      }
      .sending-textarea{
        border-radius: 18px;
      }
      .like{
        margin-left: 21px;
        display: flex;
        align-items: center;
        .like-num{
          margin-left: 2px;
          width: 21px;
          color: #1A1A1A;
          font-size: 11px;
        }
        .liked{
          color: var(--primary-color);
        }
      }
    }
    .sending-button{
      float: right;
      margin-top: 10px;
      .un-sending-text{
        margin-right: 10px;
        border-radius: 16px;
        background-color: #FFFFFF;
        color: #B3B3B3;
        border: 1px solid #CCCCCC;
        font-size: 14px;
        padding: 7px 12px;
      }
      .sending-text{
        margin-right: 10px;
        border-radius: 16px;
        background-color: var(--primary-color);;
        color: white;
        font-size: 14px;
        padding: 7px 12px;
      }
    }
  }
}

/deep/.van-image__img{
  border-radius: 8px;
}
</style>
